import {useSelector} from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import {Box, Card, DialogTitle, IconButton, Stack, Switch, Typography} from '@mui/material';
import {styleBreakWord} from 'src/utils/styleAssets';
import {formatPhoneNumber} from 'src/utils/format-phone-number';
import DialogBody from '../dialog-body';
import {useResponsive} from 'src/hooks/use-responsive';
import UserFillIcon from 'src/assets/icons/user-fill-icon'
import {ReactComponent as Alfa} from 'src/assets/icons/Alfa.svg';
import {useState} from 'react';
import AlfaModal from './alfa-modal';
import {employeesApi} from 'src/store/employees/employeesApi';


const InfoItem = ({label, value}) => {
  return (
    <Stack direction='row' spacing={1} justifyContent='space-between'>
      <Typography variant='body2' sx={{color: '#637381'}}>
        {label}
      </Typography>
      <Typography variant='body2' sx={{color: '#212B36'}}>
        {value ? value : '—'}
      </Typography>
    </Stack>
  )
}

export default function ProfileDrawer({onClose, alfaSwitch, setAlfaSwitch, getMy}) {
  const smDown = useResponsive('down', 'sm');
  const userData = useSelector(store => store.user?.permissions?.user_data)

  const [triggerUpdateEmployeeId, updateEmployeeIdQuery] = employeesApi.useLazyUpdateEmployeeIdQuery()

  const [showAlfaModal, setShowAlfaModal] = useState()


  const onApplyAlfa = async () => {
    const res = await triggerUpdateEmployeeId({
      id: userData?.employee_id,
      enable_alfa_id_auth: !alfaSwitch
    })

    if (res?.status === 'fulfilled') {
      setAlfaSwitch(!!res?.data?.enable_alfa_id_auth)
      setShowAlfaModal(false)
    }
  }

  return (
    <>
      <AlfaModal
        open={showAlfaModal}
        onClose={() => setShowAlfaModal(false)}
        enableAlfaIdAuth={alfaSwitch}
        onApply={onApplyAlfa}
        loading={updateEmployeeIdQuery.isFetching}
      />
      <DialogTitle
        sx={{
          padding: "20px",
          ...(smDown && {
            padding: '0 20px',
          }),
        }}
      >
        <Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction='row' alignItems='center' spacing={2}>
              <Stack
                alignItems='center'
                justifyContent='center'
                sx={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#F4F6F8',
                  borderRadius: '8px',
                }}>
                <UserFillIcon
                  sx={{
                    height: '26px',
                    width: '26px',
                    ['path']: {fill: '#637381'}
                  }} />
              </Stack>
              <Stack sx={smDown ? {margin: "18px 0"} : undefined}>
                <Typography variant='h4' sx={{color: '#212B36', ...styleBreakWord}}>
                  {userData?.name || '—'}
                </Typography>
              </Stack>
            </Stack>
            <Stack spacing={0.3} alignItems='flex-end'>
              <IconButton size="large" onClick={onClose} sx={{maxWidth: '48px', maxHeight: '48px'}}>
                <CloseIcon size="small" />
              </IconButton>
            </Stack>
          </Stack>
        </Box>
      </DialogTitle>
      <DialogBody>
        <Box mt={3}>
          <Card sx={{padding: '16px'}}>
            <Stack spacing={1}>
              <InfoItem
                label='Логин'
                value={getMy?.username}
              />
              <InfoItem
                label='Телефон'
                value={userData?.phone ? formatPhoneNumber(userData.phone) : ''}
              />
              <InfoItem
                label='Email'
                value={userData?.email}
              />
              <InfoItem
                label='Должность'
                value={userData?.position}
              />
            </Stack>
          </Card>
        </Box>

        <Box mt={1}>
          <Card sx={{padding: '16px'}}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>

              <Alfa />

              <Switch checked={alfaSwitch} onChange={() => {
                setShowAlfaModal(true)
              }} />
            </Stack>
          </Card>
        </Box>

      </DialogBody>
    </>
  );
}

export {ProfileDrawer}
